import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { TimeUntilNext } from 'atoms/ticker/TimeUntilNext';

const messages = defineMessages({
  timeLeft: {
    id: 'CardSwap.TimeUntilNext.timeLeft',
    defaultMessage: 'Free swap in {timeLeft}',
  },
});

const FullScreenCentered = styled(Horizontal).attrs({ gap: 0, center: true })``;

const TimeUntilNextStyled = styled(TimeUntilNext)`
  font: var(--t-24);
`;
type Props = {
  next: Date;
};
export const NextTradeCountdown = ({ next }: Props) => {
  return (
    <FullScreenCentered>
      <TimeUntilNextStyled timeLeftMessage={messages.timeLeft} next={next} />
    </FullScreenCentered>
  );
};
